import { FC } from "react";

import { UserRole } from "types/BETypes";
import { getUserRoleName } from "helpers";

import { Container, Role } from "./styles";

interface IProps {
  userRole: UserRole;
}

export const UserRoleLabel: FC<IProps> = ({ userRole }) => {
  const translatedRole = getUserRoleName(userRole);
  return (
    <Container>
      <Role userRole={userRole} component="span">
        {translatedRole}
      </Role>
    </Container>
  );
};
